import { IFlightData, IGroupParam } from 'detail/types';
import useFavorite from 'hooks/useFavorite';

interface IProps {
  areaCode: string;
  flightData: IFlightData;
  groupParam: IGroupParam;
}

const ZzimButton = ({ areaCode, flightData, groupParam }: IProps) => {
  const { isFav, handleFavorite } = useFavorite(
    flightData,
    groupParam,
    '찜한 상품 목록에 추가할 수 없습니다.\n잠시 후 다시 시도해 주시기 바랍니다.',
    '찜한 상품 목록(최대 30개)에 추가 되었습니다.\n찜한 내용은 마이페이지에서 확인할 수 있습니다.',
  );

  return (
    <button
      type="button"
      className="zzim"
      aria-checked={isFav}
      data-event-nlog="click"
      data-event-area-code={`${areaCode}.save`}
      onClick={handleFavorite}
    >
      찜
    </button>
  );
};

export default ZzimButton;
